import {LayoutConfigModel} from '../_base/layout';

export class LayoutConfig {
	public defaults: LayoutConfigModel = {
		demo: 'demo4',
		// == Base Layout
		self: {
			layout: 'fluid', // fluid|boxed
			body: {
				// 'background-image': './assets/media/bg/BG-ballerina.jpg',
				// 'background-position': 'bottom center',
				// 'background-size': 'cover',
				// 'background-attachment': 'fixed',
			},
			logo: {
				'logo':'./assets/media/logos/ballerina-logo-t-menu.png',
				'sticky': './assets/media/logos/logo-footer-stick.png',
			},
		},
		// == Page Splash Screen loading
		loader: {
			enabled: true,
			type: 'spinner-logo',
			logo: './assets/media/logos/favicon-2.jpg',
			message: 'Espere un momento...',
		},
		// == Colors for javascript
		colors: {
			state: {
				brand: 'cyan',
				light: '#ffffff',
				dark: '#282a3c',
				primary: '#E76D69',
				success: '#34bfa3',
				info: '#36a3f7',
				warning: '#ffb822',
				danger: '#fd3995',
			},
			base: {
				label: [
					'#c5cbe3',
					'#a1a8c3',
					'#3d4465',
					'#3e4466',
				],
				shape: [
					'#f0f3ff',
					'#d9dffa',
					'#afb4d4',
					'#646c9a',
				],
			},
		},
		header: {
			self: {
				width: 'fixed',
				fixed: {
					desktop: {
						enabled: true,
						mode: 'menu',
					},
					mobile: true,
				},
			},
			menu: {
				self: {
					display: true,
					'root-arrow': false,
				},
				desktop: {
					arrow: true,
					toggle: 'click',
					submenu: {
						skin: 'light',
						arrow: true,
					},
				},
				mobile: {
					submenu: {
						skin: 'dark',
						accordion: true,
					},
				},
			},
		},
		subheader: {
			display: true,
			layout: 'subheader-v4',
			width: 'fixed',
			style: 'transparent',
		},
		content: {
			width: 'fixed',
		},
		footer: {
			self: {
				width: 'fixed',
				layout: 'extended',
			},
		},
	};

	/**
	 * Good place for getting the remote config
	 */
	public get configs(): LayoutConfigModel {
		return this.defaults;
	}
}
